import React from "react"
import PropTypes from "prop-types"
import {Provider} from "react-redux"
import {BrowserRouter, Route, Routes} from "react-router-dom"
import {Page} from "./constants/page/pages"
import {PagesArchitecture} from "./constants/page/pagesArchitecture"
import {AsyncTechnicalErrorScene} from "./layouts/asyncScenes"
import MainLayoutContainer from "./layouts/mainLayout"
import StyleLoaderContainer from "./shared-components/components/StyleLoader/styleLoaderContainer"
import TextsProvider from "./shared-components/components/TextsProvider/textsProvider"
import {MatomoTracker} from "./shared-components/components/MatomoTracker/matomoTracker"
import NavigationInitializer from "./shared-components/services/navigate"
import injectTexts from "./shared-components/styles/injectTexts"
import {getStyle, areCustomizedStyle} from "./store/selectors/localStorage/styleSelectors"
import {getTexts, isCustomizedTexts} from "./store/selectors/localStorage/textSelector"
import {getDynamicConfigurationValue} from "./store/selectors/localStorage/dynamicConfigurationSelectors"
import {getCookiesChoices} from "./store/selectors/localStorage/cookiesSelectors"
import texts from "./styles/globalText"
import {SERVIDOM_AREA} from "./shared-components/constants/areaTypes"
import sosStyle from "./styles/sosStyle"
import ErrorBoundaryContainer from "./shared-components/components/ErrorBoundary/errorBoundaryContainer"
import StyleLoaderLayout from "./layouts"

const Root = ({store, texts}) => (
    <Provider store={store}>
        <MatomoTracker getCookiesChoices={getCookiesChoices}>
            <TextsProvider texts={texts}>
                <BrowserRouter>
                    <NavigationInitializer />
                    <Routes>
                        <Route
                            element={<AsyncTechnicalErrorScene />}
                            path={PagesArchitecture[Page.TECHNICAL_ERROR].route}
                        />
                        <Route
                            element={
                                <StyleLoaderLayout
                                    customStyle={sosStyle}
                                    espaceType={SERVIDOM_AREA}
                                    getDynamicConfigurationValue={getDynamicConfigurationValue}
                                    getStyle={getStyle}
                                    getTexts={getTexts}
                                    isCustomizedStyle={areCustomizedStyle}
                                    isCustomizedTexts={isCustomizedTexts}
                                >
                                    <MainLayoutContainer />
                                </StyleLoaderLayout>
                            }
                            path="/*"
                        />
                    </Routes>
                </BrowserRouter>
            </TextsProvider>
        </MatomoTracker>
    </Provider>
)

Root.propTypes = {
    store: PropTypes.object.isRequired,
    texts: PropTypes.object.isRequired,
}

export default injectTexts(texts, Root)
